(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.factory('systemTasksService', ["$rootScope", "$q", "modals", "defaultListConverter", "systemTasksDao", "modulesDao", "http", "encryptionService", "routeHelper", function ($rootScope, $q, modals, defaultListConverter, systemTasksDao, modulesDao, http, encryptionService, routeHelper) {
        var utiles = {
            taskStatusConverter: function (text, columnId, columnsMap) {
                var dateFormat = function (text) {
                    return moment.utc(text).local().format('YYYY-MM-DD HH:mm:ss');
                };
                var blackListColumns = ['action'];
                var timeColumns = [
                    'action_created',
                    'action_updated'
                ];
                var tooltipTxt = '';
                if (columnsMap && _(columnsMap).isObject()) {
                    _(columnsMap).each(function (val, key) {
                        if (_(blackListColumns).findIndex(function (col) {
                                return col === key;
                            }) === -1) {
                            if (_(timeColumns).findIndex(function (col) {
                                    return col === key;
                                }) !== -1) {
                                tooltipTxt += key + ': ' + dateFormat(val) + '<br>';
                            } else {
                                tooltipTxt += key + ': ' + val + '<br>';
                            }
                        }
                    });
                }
                return '#' + JSON.stringify({
                    display: 'html',
                    text: '<div class="' + utiles.getStatusIcon(text) + '"></div>',
                    tooltip: tooltipTxt
                });
            },
            viewActionsTable: function (data, type) {
                if (data && data.actions) {
                    var options = {
                        columns: [
                            {
                                id: 'action_id',
                                hidden: true,
                                primary: true
                            },
                            {
                                id: 'action_type',
                                hidden: true
                            },
                            {
                                id: 'action_name',
                                hidden: true
                            },
                            {
                                id: 'action_message',
                                hidden: true
                            },
                            {
                                id: 'action_created',
                                hidden: true
                            },
                            {
                                id: 'action_updated',
                                hidden: true
                            },
                            {
                                id: 'action',
                                text: 'Action',
                                converter: 'taskActionConverter'
                            },
                            {
                                id: 'action_status',
                                text: 'Status',
                                converter: 'taskStatusConverter'
                            },
                            {
                                id: 'can_retry',
                                hidden: true
                            }
                        ],
                        options: {
                            defaultOrdering: {},
                            checkboxes: false,
                            autoUpdate: 30000
                        }
                    };
                    var tableOptions = {
                        disableTop: true,
                        disableTotalRows: false,
                        orderDisplayMode: 'highlight-column',
                        asDivs: false,
                        infinite: false,
                        reloadUuid: true,
                        showWorkingIndicator: true,
                        workingIndicatorDisableGui: false,
                        pagesAround: 2,
                        pageSize: 100,
                        pagination: {
                            pageSize: 100,
                            ordering: {}
                        },
                        actions: []
                    };
                    var taskActionConverter = function (text, columnId, columnsMap) {
                        var action = '';
                        if (columnsMap && columnsMap.action_name) {
                            action = '#' + JSON.stringify({
                                display: 'text',
                                text: columnsMap.action_name
                            });
                        }
                        if (columnsMap && columnsMap.action_message) {
                            action += '#' + JSON.stringify({
                                display: 'html',
                                text: '<br>' + columnsMap.action_message
                            });
                        }
                        return action;
                    };
                    var modalTitle = utiles.makeTitle(data.name || 'Task details', data.status);
                    var modalBtns = [// {
                        //     id: 'refresh',
                        //     label: '',
                        //     class: 'btn-no-border fa fa-refresh',
                        //     noDismiss: true,
                        //     execute: function () {}
                        // },
                        {
                            label: 'Ok',
                            class: 'btn-success'
                        }];
                    var tableArgs = {
                        options: options,
                        tableOptions: tableOptions,
                        retrieve: function () {
                            if (data.id) {
                                return systemTasksDao.task(data.id).converter(function (input, args) {
                                    if (input && input.data && input.data.actions) {
                                        if (input.data.can_retry && _(tableArgs.buttons).findIndex(function (button) {
                                                return button.label === 'Retry';
                                            }) === -1) {
                                            tableArgs.buttons.push({
                                                id: 'retry',
                                                label: 'Retry',
                                                class: 'btn-danger',
                                                disable: false,
                                                execute: function () {
                                                    $rootScope.$broadcast('change-btn-status-table-modal', {
                                                        id: 'retry',
                                                        disable: true
                                                    });
                                                    utiles.retryTask(input.data).then(function () {
                                                        $rootScope.$broadcast('do-refresh-system-task-page');
                                                        $rootScope.$broadcast('change-btn-status-table-modal', {
                                                            id: 'retry',
                                                            disable: false
                                                        });
                                                    });
                                                }
                                            });
                                        }
                                        $rootScope.$broadcast('do-refresh-actions-modal-title', {
                                            title: input.data.name,
                                            status: input.data.status
                                        });
                                        return $q.when({
                                            data: input.data.actions,
                                            total_rows: input.data.actions.length - 1 || 0
                                        });
                                    }
                                    return $q.when(input);
                                }).converter(defaultListConverter, function () {
                                    return {
                                        columns: options.columns,
                                        converters: {
                                            taskActionConverter: taskActionConverter,
                                            taskStatusConverter: utiles.taskStatusConverter
                                        }
                                    };
                                });
                            }
                            return defaultListConverter({
                                data: data.actions,
                                total_rows: data.actions.length - 1 || 0
                            }, {
                                columns: options.columns,
                                converters: {
                                    taskActionConverter: taskActionConverter,
                                    taskStatusConverter: utiles.taskStatusConverter
                                }
                            });
                        },
                        title: modalTitle,
                        customTitle: true,
                        showRefreshBtn: true,
                        cancelText: false,
                        okText: false,
                        buttons: modalBtns,
                        backdrop: type === 'office365_emails_onboarding' ? 'static' : true,
                        keyboard: false,
                        hideCloseBtn: true,
                        windowClass: 'o365-onboarding-modal-container',
                        closeOnNavigate: true,
                        loading: true
                    };
                    return modals.table(tableArgs, 'md');
                } else {
                    return routeHelper.redirectTo('system-tasks');
                }
            },
            getStatusIcon: function (status) {
                var iconClass = '';
                switch (status) {
                case 'failed':
                    iconClass = 'fa fa-times-circle fa-2x red-times';
                    break;
                case 'inprogress':
                    iconClass = 'fa fa-spinner fa-pulse fa-2x starting-badge';
                    break;
                case 'completed':
                    iconClass = 'fa fa-check-circle fa-2x green-check';
                    break;
                case 'paused':
                    iconClass = 'fa fa-pause-circle-o fa-2x warning-badge';
                    break;
                case 'stopped':
                    iconClass = 'fa fa-stop fa-2x red-times';
                    break;
                default:
                    iconClass = 'fa fa-clock-o fa-2x starting-badge';
                    break;
                }
                return iconClass;
            },
            makeTitle: function (title, status) {
                return '#' + JSON.stringify({
                    display: 'html',
                    text: '<div class="custom-title"><h4 class="title-text">' + title + '</h4><div class="action-status ' + utiles.getStatusIcon(status) + '"></div></div>',
                    class: 'custom-title-wrapper'
                });
            },
            retryTask: function (data) {
                if (data.type === 'office365_emails_onboarding') {
                    return modulesDao.retryMFAandGroupFilter();
                } else if (data.type === 'office365_emails_microsoft_encryption_rule_creation') {
                    return http.post('/api/v1/office365_emails/retrigger_encryption_rule_creation').body({ id: data.id }).run().then(function () {
                        return $q.when();
                    }).catch(function (err) {
                        if (err.status === 423 && err.data && err.data.error_type === 'O365_PROTECT_POLICY_SERVICE_USER_VERIFICATION_ERROR') {
                            return encryptionService.retryCreateEncryptionRule(err.data.message).catch(function (e) {
                                console.log('Failed on retryCreateEncryptionRule():', e);
                                return $q.when();
                            });
                        }
                        console.log('Failed!', err);
                        return $q.when();
                    });
                } else {
                    console.log('Unknown type!');
                    return $q.when();
                }
            }
        };
        return utiles;
    }]);
}());